import React from "react";

const whyCmaCards = [
  "Globally recognized certification from the U.S.",
  "Sharpens strategic decision-making and analytical skills",
  "Increases earning potential and leadership opportunities",
  "Builds in-demand skills in technology, data analytics, and AI-driven finance",
  "Makes you job-ready for high-demand finance roles worldwide",
];

const WhatCmaCourse = () => {
  return (
    <section className="w-full bg-white max-md:bg-[#f3f3f3] md:py-[50px] max-md:py-4">
      <div className="main_container">
        <div className="max-md:bg-white max-md:rounded-2xl max-md:px-4 max-md:py-4">
          {/* Section Heading */}
          <h2 className="md:text-[32px] text-2xl font-bold text-left md:text-center leading-[1.2] md:mb-8 mb-6">
            <span className="text-[#333]">What is </span>
            <span className="text-[#39F]">CMA Course?</span>
          </h2>

          {/* Intro Paragraphs */}
          <div className="max-w-[1020px] mx-auto text-left md:text-center">
            <p className="text-[#333] md:text-sm text-sm font-normal leading-normal md:mb-7 mb-5">
              So, what is CMA course, exactly? The CMA course full form is{" "}
              Certified Management Accountant , a certification issued by the
              Institute of Management Accountants (IMA), USA, designed for
              professionals who want to master financial planning, analysis,
              control, and decision-making, not just compliance and bookkeeping.
            </p>
            <p className="text-[#333] md:text-sm text-sm font-normal leading-normal md:mb-7 mb-5">
              A quick clarification for many Indian students: the Certified
              Management Accountant (CMA) course from IMA (commonly called “US
              CMA”) is a different qualification from the Indian CMA offered by
              ICMAI (Institute of Cost Accountants of India). The Indian CMA is
              a three-level, cost-accounting-focused qualification regulated
              locally; the US CMA is a two-part, globally recognized
              certification best suited if your goal is a role in an MNC, GCC,
              or an international finance career. When people search “certified
              management accountant course” or “us cma course,” this, the IMA
              credential, is almost always what they mean.
            </p>
            <p className="text-[#333] md:text-sm text-sm font-normal leading-normal">
              The CMA subjects span just two exam parts and can typically be
              completed within 8–12 months, making it one of the fastest
              globally recognized finance qualifications available today. Over
              100,000 professionals across 150+ countries have earned the CMA
              credential from IMA.
            </p>
          </div>

          {/* Sub Heading */}
          <h3 className="text-[#333] md:text-base text-base font-bold text-left md:text-center md:mt-10 mt-7 md:mb-6 mb-4">
            Why Become a CMA?
          </h3>

          {/* Why Become a CMA cards */}
          <div className="grid grid-cols-1 md:grid-cols-5 md:gap-4 gap-3">
            {whyCmaCards?.map((card, idx) => (
              <div
                key={idx}
                className="bg-[#F6F6F6] border-l-4 border-[#2A85FF] md:p-4 px-4 py-[16px]"
              >
                <p className="text-[#333] text-sm font-normal leading-normal">
                  {card}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatCmaCourse;
